'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# PhoneSVG
An SVG Phone icon
 */
var PhoneSVG = function PhoneSVG(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'Phone',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 72 75',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M0,23.7034036 L0,0 L71.8395462,0 L71.8395462,74.8784441 L50.2025932,74.8784441 C50.2979165,74.8490847 50.3949346,74.8255406 50.4931118,74.8079417 C52.737034,74.5441653 54.9979741,74.3800648 57.2200162,73.9898703 C58.9315235,73.6884117 60.5931929,73.1037277 62.3679092,72.6211507 C62.1928687,72.3780389 62.1333063,72.2722853 62.0555105,72.1871961 C60.6187196,70.6215559 59.1807131,69.0571313 57.7414911,67.4939222 C54.1385737,63.5749595 50.5380875,59.654376 46.9400324,55.7321718 C46.726094,55.4987844 46.5449757,55.4404376 46.2106969,55.5206645 C43.8148298,56.0919773 41.4007293,56.076175 38.9902755,55.6106159 C34.4015397,54.7244733 30.5628039,52.428282 27.1993517,49.2641815 C24.0449757,46.2909238 21.4424635,42.9092382 19.8512966,38.8383306 C18.2078606,34.6337115 17.7921394,30.3488655 19.1936791,25.9752836 C19.2272921,25.7779219 19.1726388,25.5757491 19.0441653,25.4222042 C17.4444895,23.6487034 15.8290113,21.8970827 14.2147488,20.1308752 C11.6142626,17.2945705 9.01377634,14.4619125 6.41329011,11.6329011 C5.49068071,10.6300648 4.5595624,9.63573744 3.59197731,8.59400324 C1.6993517,12.4971637 0.674635332,16.5437601 0.246758509,20.7495948 C0.149513776,21.7329822 0.0826580227,22.7188006 0,23.7034036 Z M21.0559157,23.7702593 C21.2431118,23.60859 21.3829011,23.4943274 21.5153971,23.3715559 C23.315235,21.7111021 25.1142626,20.0498379 26.9124797,18.3877634 C28.9789303,16.4683955 29.1867909,13.726094 27.3014587,11.6329011 C24.2544571,8.25364668 21.167342,4.90599676 18.0401135,1.58995138 C16.1815235,-0.382901135 13.3322528,-0.378038898 11.363047,1.46839546 C10.0356564,2.71555916 8.67909238,3.93233387 7.33833063,5.16491086 C6.73055105,5.72042139 6.14100486,6.28444084 5.52106969,6.86669368 L21.0559157,23.7702593 Z M64.2471637,70.7455429 C66.3196921,68.8334684 68.3691248,66.9979741 70.3553485,65.0968395 C72.1786872,63.3476499 72.2188006,60.5141815 70.5170178,58.6422204 C69.4692058,57.4898703 68.4157212,56.3419773 67.356564,55.1985413 C65.3168558,52.9801459 63.2965964,50.743517 61.2252836,48.554295 C59.4128849,46.6397893 56.5879254,46.5875203 54.6442464,48.3658833 C53.3606159,49.5393031 52.0765802,50.7119125 50.7921394,51.8837115 C50.0968395,52.5218801 49.4088331,53.1661264 48.6916532,53.8286062 L64.2471637,70.7455429 Z',
        fill: 'transparent'
      }),
      _react2.default.createElement('path', {
        d: 'M0,23.7034036 C0.0826580227,22.7188006 0.149513776,21.7329822 0.250405186,20.7508104 C0.683144246,16.5437601 1.70299838,12.4971637 3.59562399,8.5952188 C4.56807131,9.636953 5.49432739,10.6312804 6.41693679,11.6341167 C9.01904376,14.4639384 11.61953,17.2965964 14.2183955,20.1320908 C15.832658,21.8922204 17.4481361,23.649919 19.047812,25.4234198 C19.1762855,25.5769647 19.2309388,25.7791375 19.1973258,25.9764992 C17.7957861,30.3525122 18.2115073,34.6349271 19.8549433,38.8395462 C21.4461102,42.9104538 24.0486224,46.2921394 27.2029984,49.2653971 C30.5615883,52.4258509 34.4003241,54.7256888 38.9939222,55.6118314 C41.404376,56.0773906 43.8184765,56.0980551 46.2143436,55.5218801 C46.5498379,55.4416532 46.7309562,55.5 46.9436791,55.7333874 C50.5409238,59.6572123 54.14141,63.5777958 57.7451378,67.4951378 C59.1819287,69.0591572 60.6199352,70.6235818 62.0591572,72.1884117 C62.136953,72.2735008 62.1965154,72.3768233 62.3715559,72.6223663 C60.5968395,73.10859 58.9351702,73.6896272 57.2236629,73.9910859 C55.0016207,74.3812804 52.7406807,74.5453809 50.4967585,74.8091572 C50.3985812,74.8267561 50.3015632,74.8503003 50.2062399,74.8796596 L48.2576985,74.8796596 C48.141892,74.8498102 48.0246415,74.8258732 47.9064019,74.8079417 C46.0186386,74.6158833 44.1126418,74.536872 42.2467585,74.2171799 C36.6150729,73.2447326 31.4088331,71.1333063 26.5660454,68.1102107 C21.5324149,64.9667747 17.1624797,61.0599676 13.2520259,56.6158833 C9.50567261,52.3614263 6.32333874,47.7301459 3.97852512,42.5506483 C1.97528363,38.126013 0.657617504,33.5141815 0.234602917,28.6628849 C0.15923825,27.7795786 0.0810372771,26.8962723 0,26.012966 L0,23.7034036 Z',
        fill: color
      }),
      _react2.default.createElement('path', {
        d: 'M0,26.012966 C0.0810372771,26.8954619 0.159643436,27.778363 0.235818476,28.6616694 C0.658833063,33.512966 1.97649919,38.1247974 3.97974068,42.5494327 C6.32090762,47.7289303 9.50688817,52.356564 13.2495948,56.6146677 C17.1600486,61.058752 21.5299838,64.9655592 26.5636143,68.1089951 C31.4051864,71.1320908 36.6114263,73.2471637 42.2443274,74.2159643 C44.1102107,74.5356564 46.0125608,74.6146677 47.9039708,74.8067261 C48.0222104,74.8246577 48.1394609,74.8485946 48.2552674,74.8784441 L0,74.8784441 L0,26.012966 Z',
        fill: 'transparent'
      }),
      _react2.default.createElement('path', {
        d: 'M21.0559157,23.7702593 L5.52106969,6.86547812 C6.14100486,6.28687196 6.73662885,5.72285251 7.33833063,5.1636953 C8.67544571,3.93111831 10.0356564,2.7143436 11.363047,1.4671799 C13.3322528,-0.381685575 16.1815235,-0.386547812 18.0401135,1.58873582 C21.1632901,4.90559157 24.2504052,8.25364668 27.3014587,11.6329011 C29.1867909,13.726094 28.9837925,16.4683955 26.9124797,18.3877634 C25.1175041,20.0530794 23.3184765,21.7143436 21.5153971,23.3715559 C21.3829011,23.4943274 21.2431118,23.60859 21.0559157,23.7702593 Z',
        fill: color
      }),
      _react2.default.createElement('path', {
        d: 'M64.2471637,70.7455429 L48.6965154,53.834684 C49.4136953,53.1697731 50.1017018,52.5255267 50.7970016,51.8897893 C52.0798217,50.7155592 53.3638574,49.5429498 54.6491086,48.3719611 C56.5940032,46.5935981 59.4177472,46.6458671 61.2301459,48.5603728 C63.2965964,50.7483793 65.321718,52.9862237 67.3614263,55.2046191 C68.4149109,56.3496759 69.4683955,57.4975689 70.5218801,58.6482982 C72.2236629,60.5202593 72.184765,63.3537277 70.3602107,65.1029173 C68.3691248,67.0016207 66.3196921,68.8371151 64.2471637,70.7455429 Z',
        fill: color
      })
    )
  );
};

PhoneSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

PhoneSVG.displayName = 'PhoneSVG';

exports.default = PhoneSVG;
PhoneSVG.__docgenInfo = {
  'description': '# PhoneSVG\r\nAn SVG Phone icon',
  'methods': [],
  'displayName': 'PhoneSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};